import { render } from "./AlertServers.vue?vue&type=template&id=0b9e992b&scoped=true&ts=true"
import script from "./AlertServers.vue?vue&type=script&lang=ts"
export * from "./AlertServers.vue?vue&type=script&lang=ts"

import "./AlertServers.vue?vue&type=style&index=0&id=0b9e992b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9e992b"]])

export default __exports__